import { Suggestion } from '@empathy/search-types';
import { Observable } from 'rxjs/Observable';
import { container } from '../../container/container';
import { DEPENDENCIES } from '../../container/dependencies.const';
import { QueryOrigin } from '../../models';
import { MUTATIONS_KEYS } from '../../store';
import { isArrayEmptyOrNull } from '../../utils';
import { createWires } from '../wiring.util';
import { WIRE_FACTORY } from './wires.factory';

export const QUERY_ORIGIN_WIRES = createWires({
  // TODO: split suggestion selected in two: sugestionSelected & popularSearchSelected
  queryOriginDefault: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.default),
  queryOriginHistory: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.history),
  queryOriginPartial: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.partial),
  queryOriginPopularSearches: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.popularSearches),
  queryOriginNextQuery: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.nextQuery),
  queryOriginNextQueryGrid: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.nextQueryGrid),
  queryOriginNextQuerySuggestion: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.nextQueriesSuggestions),
  queryOriginRelatedTag: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.relatedTag),
  queryOriginSpellCheck: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.spellCheck),
  queryOriginTopTerm: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.empathizeTerm),
  queryOriginTopTermCategory(observable: Observable<Suggestion>, { store }) {
    observable.subscribe(suggestion => {
      if (isArrayEmptyOrNull(suggestion.facets)) {
        store.commit(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.empathizeTerm);
      } else {
        store.commit(MUTATIONS_KEYS.tracking.setQueryOrigin, QueryOrigin.empathizeCategory);
      }
    });
  },
  queryOriginUrl(observable: Observable<any>, { store }) {
    observable.subscribe(event => {
      const hasUserNavigatedBackFromPDP = container.get<() => boolean>(DEPENDENCIES.HasUserNavigatedBackFromPDP);
      let queryOrigin = QueryOrigin.linked;

      if (event && event.type === 'popstate') {
        queryOrigin = QueryOrigin.backFromSearch;
      } else if (hasUserNavigatedBackFromPDP()) {
        queryOrigin = QueryOrigin.backFromPDP;
      }

      store.commit(MUTATIONS_KEYS.tracking.setQueryOrigin, queryOrigin);
    });
  }
});
